import { listproduct,listcate,listCateNew,productinfo,listremark,orderOn,getExpress,GetConfig,add,getInquiryList,details, } from '@/api/enable'

const actions = {
    listproduct(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listproduct(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listcate(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listcate(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listCateNew(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listCateNew(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    productinfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            productinfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listremark(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            listremark(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    orderOn(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            orderOn(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getExpress(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            getExpress(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    GetConfig(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            GetConfig(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    add(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            add(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getInquiryList(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            getInquiryList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    details(state, info){
        const infoData = info
        return new Promise((resolve,reject) => {
            details(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    

}

export default {
  namespaced: true,
  actions
}
